export default __webpack_public_path__ + "static/media/right_arrow.86a7ce2b.svg";